/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PeriodsTableComponent} from './periods-table.component';
import {TableModule} from '../../shared/table/table.module';
import {PaginationModule} from '../../shared/pagination/pagination.module';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';
import {PeriodBundlesTableModule} from '../period-bundles-table/period-bundles-table.module';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';
import {InputModule} from '../../shared/input/input.module';
import {PeriodsInfoChartModule} from '../periods-info-chart/periods-info-chart.module';
import {FlyingMenuModule} from '../../shared/flying-menu/flying-menu.module';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {BundlesPipesModule} from '../shared/pipes/bundles-pipes.module';

@NgModule({
    declarations: [PeriodsTableComponent],
    imports: [
        CommonModule,
        TableModule,
        PaginationModule,
        TooltipModule,
        PeriodBundlesTableModule,
        LoadingSpinnerModule,
        InputModule,
        FlyingMenuModule,
        PipesModule,
        BundlesPipesModule,
        PeriodsInfoChartModule
    ],
    exports: [PeriodsTableComponent]
})
export class PeriodsTableModule {
}
